<template>
    <div class="pl48" :id="row._id">
        <div class="row-item mb10" v-for="(child,index) in row.children||[]" :key="'row-item'+index">
            <h3 class="title-group font12px mb6">
                <span class="plat-name inline-block">{{child.plat_name}}</span>（{{(child.children||[]).length}}）</h3>
            <div class="sub-row-item relative" 
                v-for="(subItem,subIndex) in child.children||[]" 
                :key="'sub-row-item'+subIndex"
                :class="{ active: isActave(subItem) }"
            >
                <div class="inline-block" style="width: 300px;">
                    <p class="ellipsis pl20 sub-row-p">
                        <span class="inline-block ver-middle ellipsis full-w" :title="subItem.subproject_name+'('+subItem.subproject_id+')'">{{subItem.subproject_name||'--'}}（{{subItem.subproject_id}}）</span>
                    </p>
                    <p class="ellipsis pl20 sub-row-p" :title="subItem.subproject_content">{{subItem.subproject_content||'--'}}</p>
                </div>
                <div class="inline-block tac" style="width: 120px;">
                    <span v-if="editable" class="el-icon-edit-outline text-color-primary font14px pointer action-btn relative mr10" @click="editRow(subItem)" style="left: -12px;" title="编辑" v-matomo="{behaviorCategory: '项目管理',name: '列表(编辑-项目归属)' }"></span>
                    <span v-else>--</span>
                </div>
                <div class="inline-block" style="width: 200px">
                    <span class="pl10 pr10">{{subItem.plat_name}}</span>
                </div>
                <div class="inline-block" style="width: 150px">
                    <span class="pl10 pr10">{{subItem.creator_or_integrator}}</span>
                </div>
                <div class="inline-block" style="width: 150px">
                    <span class="pl10 pr10">{{subItem.ci_time}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ExpandItem",
        props:{
            row:Object,
            editable:Boolean,
            project: String
        },
        methods:{
            editRow(row){
                this.$emit('edit',row,this.row);
            },
            isActave(row) {
                const { subproject_content = '', subproject_id = '', subproject_name  = ''} = row;
                if(!this.project) {
                    return false;
                }
                return (
                    subproject_content.indexOf(this.project) !== -1 ||
                    subproject_id.indexOf(this.project) !== -1 ||
                    subproject_name.indexOf(this.project) !== -1
                );
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ver-middle{
        vertical-align: middle;
    }
    .sub-row-p{
        line-height: 16px;
    }

    .sub-row-item{
        height: 50px;
        display: flex;
        align-items: center;
        &:hover{
            background-color: #f3f6f9;
        }
        &.active{
            background-color: #e4e4e4;
        }
    }
    .plat-name{
        width: 3em;
    }
</style>
